// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"c687b7d8","256":"6d267e5b","329":"4aeb4e80","535":"86c08ab4","888":"0f4c20d0","922":"7581813b","991":"bcca2a58"}[chunkId] + ".chunk.js";
};